export const HOME_PAGE_ROUTE: string = "/";
export const LOGIN_PAGE_ROUTE: string = "/login";
export const DEMO_CREATE_ROUTE: string = "/demo";
export const CHANGE_PASSWORD_PAGE_ROUTE: string = "/change-password";
export const FORGOT_PASSWORD_PAGE_ROUTE: string = "/forgot-password";
export const RESET_PASSWORD_PAGE_ROUTE: string = "/reset-password";
export const PRIVACY_POLICY_PAGE_ROUTE: string = "/privacy-policy";
export const TERMS_OF_USE_PAGE_ROUTE: string = "/terms-of-use";
export const HR_EMPLOYEES_PAGE_ROUTE: string = "/hr/employees";
export const HR_HIRING_PAGE_ROUTE: string = "/hr/hiring";
export const HR_EXPERTS_PAGE_ROUTE: string = "/hr/experts";
export const HR_APPLY_PAGE_ROUTE: string = "/hr/apply/:token";
export const HR_CONTRACTS_PAGE_ROUTE: string = "/hr/contracts";
export const HR_LEAVES_PAGE_ROUTE: string = "/hr/leaves";
export const HR_FILL_CONTRACT_PAGE_ROUTE: string = "/hr/contracts/fill/:applicationId";
export const HR_EDIT_CONTRACT_PAGE_ROUTE: string = "/hr/contracts/edit/:contractId";
export const LEGAL_TEMPLATES_PAGE_ROUTE: string = "/legal/templates";
export const LEGAL_APPLICATIONS_PAGE_ROUTE: string = "/legal/applications";
export const LEGAL_ATTACHED_DOCUMENTS_PAGE_ROUTE: string = "/legal/attached-documents";
export const GUEST_SIGNING_PAGE_ROUTE: string = "/sign/document";
// The token travels in the path so a reload can re-open the session; the bare
// route stays registered for links already sent with the legacy #token= form.
export const GUEST_SIGNING_TOKEN_PAGE_ROUTE: string = "/sign/document/:token";
export const SIGNING_DONE_PAGE_ROUTE: string = "/signing/done";
export const SIGNING_INVITATION_PAGE_ROUTE: string = "/signing/invitations/:invitationId";
export const ACCOUNTING_TIMESHEETS_PAGE_ROUTE: string = "/accounting/timesheets";
export const ACCOUNTING_TIMESHEET_DETAIL_PAGE_ROUTE: string = "/accounting/timesheets/:id";
export const ACCOUNTING_PURCHASES_PAGE_ROUTE: string = "/accounting/purchases";
export const ACCOUNTING_WAREHOUSE_PAGE_ROUTE: string = "/accounting/warehouse";
export const ACCOUNTING_WAREHOUSE_REQUESTS_PAGE_ROUTE: string = "/accounting/warehouse/requests";
export const ACCOUNTING_FIXED_ASSETS_PAGE_ROUTE: string = "/accounting/assets";
export const ACCOUNTING_DEPRECIATION_PAGE_ROUTE: string = "/accounting/assets/depreciation";
export const WAREHOUSE_PUBLIC_UNIT_PAGE_ROUTE: string = "/warehouse/units/:barcode";
export const ACCOUNTING_REPORTS_PAGE_ROUTE: string = "/accounting/reports";
export const ACCOUNTING_FINANCIAL_REPORTS_PAGE_ROUTE: string = "/accounting/financial-reports";
export const ACCOUNTING_EQUITY_CHANGES_REPORT_PAGE_ROUTE: string = "/accounting/financial-reports/equity-changes";
export const ACCOUNTING_TAX_ROUTE: string = "/accounting/tax";
export const ACCOUNTING_RENTALS_PAGE_ROUTE: string = "/accounting/rentals";
export const ACCOUNTING_INCOME_PAGE_ROUTE: string = "/accounting/income";
export const ACCOUNTING_CONTRACTOR_PAYROLL_PAGE_ROUTE: string = "/accounting/contractor-payroll";
export const ACCOUNTING_CONTRACTOR_PAYROLL_DETAIL_PAGE_ROUTE: string = "/accounting/contractor-payroll/detail";
export const FINANCE_PAGE_ROUTE: string = "/finance";
export const BANKING_PAGE_ROUTE: string = "/banking";
export const PROFILE_PAGE_ROUTE: string = "/self/profile";
export const PERSONAL_SHEET_DRAFT_PAGE_ROUTE: string = "/self/personal-sheet/complete";
export const REQUESTS_PAGE_ROUTE: string = "/self/requests";
export const REQUESTS_ACTIVE_PAGE_ROUTE: string = "/self/requests/active";
export const REQUESTS_HISTORY_PAGE_ROUTE: string = "/self/requests/history";
export const CALCULATIONS_PAGE_ROUTE: string = "/self/calculations";
export const PENDING_ACTIONS_PAGE_ROUTE: string = "/self/pending";
export const SUPPORT_PAGE_ROUTE: string = "/support";
export const PROJECTS_PAGE_ROUTE: string = "/projects";
export const PROJECT_DETAIL_ROUTE: string = "/projects/:id";
export const PROJECT_MONITORING_ROUTE: string = "/projects/monitoring";
export const PROJECT_REPORTS_ROUTE: string = "/reporting/projects";
export const PROJECT_REPORT_PREVIEW_ROUTE: string = "/reporting/projects/:id/preview";
export const ANNUAL_REPORTS_ROUTE: string = "/reporting/annual";
export const ANNUAL_REPORT_PREVIEW_ROUTE: string = "/reporting/annual/:id/preview";
export const ESG_REPORTS_ROUTE: string = "/reporting/esg";
export const ESG_REPORT_PREVIEW_ROUTE: string = "/reporting/esg/:id/preview";
export const SROI_ROUTE: string = "/reporting/sroi";
export const SROI_PROJECT_ROUTE: string = "/reporting/sroi/:projectId";
// Public, no-auth: the personal link a respondent gets by email
// (`invitation_service.public_survey_url`) — mounted under `publicRoutes`
// with `PublicLayout`, never the authenticated app shell.
export const SROI_SURVEY_PAGE_ROUTE: string = "/survey/:token";
export const BOARD_PAGE_ROUTE: string = "/board";
export const ORGANIZATION_PAGE_ROUTE: string = "/organization";
export const CHAT_PAGE_ROUTE: string = "/chat";
export const CHAT_ADMIN_PAGE_ROUTE: string = "/chat/admin";
export const COMMUNITY_PAGE_ROUTE: string = "/community";
export const REGISTRY_PROJECTS_PAGE_ROUTE: string = "/registries/projects";
export const REGISTRY_ORGANIZATIONS_PAGE_ROUTE: string = "/registries/organizations";
export const REGISTRY_ORGANIZATION_PAGE_ROUTE: string = "/registries/organizations/:id";
export const REGISTRY_PROJECT_PAGE_ROUTE: string = "/registries/organizations/:id/projects/:projectId";
export const REGISTRY_PUBLICITY_PAGE_ROUTE: string = "/registries/publicity";
export const FSM_SUBMISSIONS_PAGE_ROUTE: string = "/fsm/submissions";
export const FSM_MY_REPORTS_PAGE_ROUTE: string = "/self/my-reports";
export const HR_IMPORT_WORKER_PAGE_ROUTE: string = "/hr/import-worker";
export const HR_WORKER_DETAIL_PAGE_ROUTE: string = "/hr/employees/:id";
export const PROJECTS_VOLUNTEERS_PAGE_ROUTE: string = "/volunteers";
export const ACCOUNTING_PROJECT_TABLE_PAGE_ROUTE: string = "/project-table";
export const ACCOUNTING_ADVANCES_PAGE_ROUTE: string = "/accounting/advances";
